import { staticFile } from '@common/utils'
import Avatar from '@components/student-dashboard/gamification/avatar'
import { StudentProfileSummaryProps } from '@lib/types/gamification'
import Link from 'next/link'
import QuizLeaderboardTable from './quiz-leaderboard-table'

type LeaderDetailCard = {
  leaderDetails: StudentProfileSummaryProps
  isOverallLeader?: boolean
}

const LeaderDetailsCard = ({
  leaderDetails,
  isOverallLeader = false,
}: LeaderDetailCard) => (
  <div className="flex">
    <Link href={`/@${leaderDetails?.student?.username}`}>
      <a className="relative h-32 w-32 items-center">
        <img
          src={staticFile(
            `/images/gamification/${
              isOverallLeader ? 'gold-leaf' : 'silver-leaf'
            }.svg`
          )}
          className="absolute mx-auto inset-x-0"
          alt="golden-leaf"
          style={{ width: '7rem' }}
        />
        <Avatar
          gender={leaderDetails.student.gender}
          name={leaderDetails.student.name}
          className="w-20 h-20 rounded-full mx-auto mt-1"
          image={leaderDetails.student.avatar}
        />
      </a>
    </Link>
    <div className="flex flex-col ml-6">
      <p className="font-600 text-orange text-sm">
        {isOverallLeader ? 'OVERALL LEADER' : 'WEEKLY LEADER'}
      </p>
      <Link href={`/@${leaderDetails?.student?.username}`}>
        <a className="hover:underline text-2xl text-grey">
          {leaderDetails.student?.name}
        </a>
      </Link>
      <p>
        <span className="text-grey-800 text-lg">Points: </span>
        <span className="text-orange font-600 text-lg">
          {leaderDetails.points}
        </span>
      </p>
    </div>
  </div>
)

type Props = {
  overallLeaderDetails: StudentProfileSummaryProps
  weeklyLeaderDetails: StudentProfileSummaryProps
}

const GlobalQuizLeaderboard = ({
  overallLeaderDetails,
  weeklyLeaderDetails,
}: Props) => (
  <div>
    <div className="bg-white p-5 pt-10 lg:p-10 flex flex-col lg:flex-row space-y-8 lg:space-y-0 justify-around rounded-md">
      {overallLeaderDetails && (
        <LeaderDetailsCard
          leaderDetails={overallLeaderDetails}
          isOverallLeader
        />
      )}
      {weeklyLeaderDetails && (
        <LeaderDetailsCard leaderDetails={weeklyLeaderDetails} />
      )}
    </div>
    <QuizLeaderboardTable />
  </div>
)

export default GlobalQuizLeaderboard
